/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  getAllPackages({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/package", data)
        .then((response) => {
          commit('SET_PACKAGES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAPackage({ commit }, packageId) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/package/"+packageId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createPackage({ commit }, packageData) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/package/create", packageData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updatePackage({ commit }, packageData) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/package/"+packageData.id, packageData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
}
